const init = () => {
  const sealTop = document.querySelector('.js-seal-top');
  const sealTopLength = sealTop.getTotalLength();
  const sealBottom = document.querySelector('.js-seal-bottom');
  const sealBottomLength = sealBottom.getTotalLength();
  const sealDivider = document.querySelector('.js-seal-divider');
  const sealDividerLength = sealDivider.getTotalLength();

  sealTop.style.setProperty('--stroke-l', `${sealTopLength}px`);
  sealBottom.style.setProperty('--stroke-l', `${sealBottomLength}px`);
  sealDivider.style.setProperty('--stroke-l', `${sealDividerLength}px`);
};

export default {init};
